import { writable } from 'svelte-local-storage-store';
export const paginationLimitStore = writable('pagination-limit', 10);
